import StockTabPanelRecycling from './StockTabPanelRecycling';

export default StockTabPanelRecycling;
